import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/profile";
import "./AdditionalRegInfo.scss";

type Props = {
  title: string;
  status: boolean;
  show?: boolean;
  labelFormat?: string;
};

const AdditionalRegInfo = (props: Props) => {
  const { title, status, show = true, labelFormat = "true_false" } = props;
  const { t } = useTranslation(["profile"]);

  if (!show) return null;

  const getStatusLabel = () => {
    if (labelFormat === "yes_no") {
      return status
        ? t("aboProfile.overviewTab.yes", defaultContent["aboProfile"]["overviewTab"]["yes"])
        : t("aboProfile.overviewTab.no", defaultContent["aboProfile"]["overviewTab"]["no"]);
    }
    return status
      ? t("aboProfile.overviewTab.true", defaultContent["aboProfile"]["overviewTab"]["true"])
      : t("aboProfile.overviewTab.false", defaultContent["aboProfile"]["overviewTab"]["false"]);
  };

  return (
    <div className="additional-reg-info">
      <div className="additional-reg-info__title">
        {String(t(`aboProfile.overviewTab.${title}`, defaultContent["aboProfile"]["overviewTab"][title]))}
      </div>
      <div className="additional-reg-info__status">{String(getStatusLabel())}</div>
    </div>
  );
};

export default AdditionalRegInfo;
